var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 18H52.2L36 1.8V15C36 16.8 37.2 18 39 18ZM39 24C33.9 24 30 20.1 30 15V0H15C9.9 0 6 3.9 6 9V51C6 56.1 9.9 60 15 60H45C50.1 60 54 56.1 54 51V24H39ZM21 18H24C25.8 18 27 19.2 27 21C27 22.8 25.8 24 24 24H21C19.2 24 18 22.8 18 21C18 19.2 19.2 18 21 18ZM39 48H21C19.2 48 18 46.8 18 45C18 43.2 19.2 42 21 42H39C40.8 42 42 43.2 42 45C42 46.8 40.8 48 39 48ZM39 36H21C19.2 36 18 34.8 18 33C18 31.2 19.2 30 21 30H39C40.8 30 42 31.2 42 33C42 34.8 40.8 36 39 36Z",
    fill: "#ECC90F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f5a65956d8c4cc0b7791f4890d3e5fab.svg";
export { ForwardRef as ReactComponent };